import { useTranslation } from 'react-i18next';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import classNames from 'classnames';

import { LoadingLogo } from 'components/Loading/LoadingLogo';

type InfiniteScrollProps = {
  hasMore: boolean;
  loadMore: () => void;
  loading: boolean;
  noMoreItemsLabel?: string;
  noMoreItemsEnabled: boolean;
  className?: string;
};

export function InfiniteScroll({
  hasMore,
  loading,
  loadMore,
  noMoreItemsEnabled,
  noMoreItemsLabel,
  className,
}: InfiniteScrollProps) {
  const { t } = useTranslation();
  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: loadMore,
    disabled: false,
    rootMargin: '0px 0px 0px 0px',
  });

  return (
    <div className={classNames('flex min-h-px w-full justify-center items-center py-12', className)} ref={sentryRef}>
      {loading ? (
        <span className="size-12 origin-center">
          <LoadingLogo />
        </span>
      ) : null}

      {!hasMore && !loading && noMoreItemsEnabled ? (
        <>
          <div className="h-px flex-1 bg-gray-200"></div>
          <div className="relative bg-white px-4">
            <span className="text-sm text-gray-500">
              {noMoreItemsLabel || t('common:components.infiniteScroll.noMoreItems')}
            </span>
          </div>
          <div className="h-px flex-1 bg-gray-200"></div>
        </>
      ) : null}
    </div>
  );
}
